import { viewMyPickupScheduleData } from "constants-lib/seo/viewMyPickupScheduleData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const viewMyPickupSchedule = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add View Pickup Schedule JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addViewMyPickupSchedule = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/where-can-i-view-my-pickup-schedule`,
    ) &&
    document.getElementById(`viewMyPickupSchedule`) === null
  ) {
    const script = viewMyPickupScheduleJSONLD()
    addJSONLDToHead(script, `viewMyPickupSchedule`)
  } else {
    removeElement(`viewMyPickupSchedule`)
  }
}

// JSON LD template for View Pickup Schedule
const viewMyPickupScheduleJSONLD = () => {
  const viewMyPickupTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: viewMyPickupSchedule(viewMyPickupScheduleData),
  }
  return viewMyPickupTemplate
}
